import React from 'react';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { Button } from 'react-bootstrap';

const OpenCallPageButton = ({ callId, compactMode = true, onOpenCall = () => {} }) => {
    const isDisabled = !callId;
    const handleOpen = (event) => {
        event?.preventDefault?.();
        if (isDisabled) return;
        onOpenCall(callId);
        window.dispatchEvent(new CustomEvent('call-center:open-active-call', { detail: { callId } }));
    };

    return (
        <Button
            type="button"
            variant="link"
            onClick={handleOpen}
            className={`${compactMode ? 'p-2 m-0' : 'ml-2'} text-decoration-none ${isDisabled ? 'disabled' : ''}`}
            title="View Call Details"
            disabled={isDisabled}
        >
            {compactMode ? <BsBoxArrowUpRight size={14} /> : <BsBoxArrowUpRight size={14} />}
        </Button>
    );
};
export default OpenCallPageButton;
